module.exports = __webpack_public_path__ + "img/img_ch2.11ab88a6.jpg";